import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=9c2f4f5c&"
import script from "./RightSidebar.vue?vue&type=script&lang=js&"
export * from "./RightSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports